module.exports = __webpack_public_path__ + "img/map.927b449f.png";